import React from 'react';
import _ from 'lodash';
import { Box, Typography } from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BlockIcon from '@mui/icons-material/Block';
import ErrorIcon from '@mui/icons-material/Error';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';

export default function Warnings(props) {
    return (
        <div>
            {props.platformName === 'iOS' && (
                <Box display='flex' alignItems='center' marginBottom={3}>
                    <ErrorIcon sx={{ mr: 4 }} fontSize='large' />
                    <Typography align="justify" variant="subtitle1">
                        O seu aplicativo iOS só será publicado caso você tenha uma conta de desenvolvedor Apple do tipo empresarial ativa e tenha concedido um acesso à sua conta para o email apps@mobilizei.com.br.
                    </Typography>
                </Box>
            )}
            {props.platformName?.toLowerCase() === 'android' && (
                <Box display='flex' alignItems='center' marginBottom={3}>
                    <ErrorIcon sx={{ mr: 4 }} fontSize='large' />
                    <Typography align="justify" variant="subtitle1">
                        O seu aplicativo Android só será publicado caso você tenha uma conta de desenvolvedor Google Play do tipo organizacional ativa e, tenha concedido um acesso à sua conta para o email apps@mobilizei.com.br.
                    </Typography>
                </Box>
            )}
            <Box display='flex' alignItems='center' marginBottom={3}>
                <CalendarTodayIcon sx={{ mr: 4 }} fontSize='large' />
                <Typography align="justify" variant="subtitle1">
                    O prazo médio para a disponibilização do aplicativo {props.platformName === 'iOS' ? 'na App Store' : 'na Google Play'} é de até <b>{props.deadlineInDays} dias úteis</b>, podendo variar conforme a velocidade de revisão {props.platformName === 'iOS' ? 'da Apple' : 'do Google'}.
                </Typography>
            </Box>
            <Box display='flex' alignItems='center' marginBottom={3}>
                <BlockIcon sx={{ mr: 4 }} fontSize='large' />
                <Typography align="justify" variant="subtitle1">
                    <strong>Não é possível cancelar</strong> um pedido de publicação após ele ser enviado. Portanto, uma nova solicitação só poderá ser feita após a conclusão da anterior.
                </Typography>
            </Box>

            {!_.isEmpty(props.downloadUrl) && (
                <Box display='flex' alignItems='center' marginBottom={3}>
                    <SystemUpdateIcon sx={{ mr: 4 }} fontSize='large' />
                    <Typography align="justify" variant="subtitle1">
                        Seu aplicativo continuará disponível para download enquanto a nova versão está em fase de aprovação.
                    </Typography>
                </Box>
            )}
        </div>
    )
}